import React from "react";

export function FilmStripLoader({ className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Bordi pellicola */}
      <rect x="4" y="0" width="10" height="64" rx="1" fill="currentColor" />
      <rect x="50" y="0" width="10" height="64" rx="1" fill="currentColor" />

      {/* Fori laterali */}
      <g className="opacity-90 dark:opacity-40">
        <rect x="6" y="6" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="6" y="16" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="6" y="26" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="6" y="36" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="6" y="46" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="6" y="56" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />

        <rect x="52" y="6" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="52" y="16" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="52" y="26" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="52" y="36" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="52" y="46" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
        <rect x="52" y="56" width="6" height="4" rx="1" fill="white" className="dark:fill-black" />
      </g>

      {/* Fotogrammi che scorrono */}
      <g className="animate-filmscroll">
        <rect x="18" y="0" width="28" height="20" rx="1" fill="currentColor" opacity="0.9" />
        <rect x="18" y="24" width="28" height="20" rx="1" fill="currentColor" opacity="0.9" />
        <rect x="18" y="48" width="28" height="20" rx="1" fill="currentColor" opacity="0.9" />
        <rect x="18" y="72" width="28" height="20" rx="1" fill="currentColor" opacity="0.9" />
      </g>
    </svg>
  );
}
